import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { BlobCheck } from "./decor";
import real5 from "../assets/real-5.jpg";

const BLOB_COLORS = ["#D8E2EE", "#EAE2F8", "#F8DFD6", "#E9C89B"];

export default function WhyChoose() {
  const { s } = useLang();
  return (
    <section id="why-us" data-testid="why-us-section" className="relative bg-coral pb-20 sm:pb-24 pt-4 overflow-hidden">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center pt-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="w-72 h-72 sm:w-96 sm:h-96 rounded-full overflow-hidden ring-8 ring-white/70 shadow-card mx-auto">
            <img
              data-testid="why-photo"
              src={real5}
              alt="Our rainbow affirmation wall at Neni’s Playhouse Childcare"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>

        <div className="text-center lg:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl"
          >
            {s.why.h}
          </motion.h2>

          <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-10">
            {s.why.items.map((r, i) => (
              <motion.div
                key={r.t}
                data-testid={`why-card-${i + 1}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-start gap-4 text-left"
              >
                <BlobCheck color={BLOB_COLORS[i]} />
                <div>
                  <h3 className="font-display font-semibold text-white uppercase tracking-wide text-[15px]">
                    {r.t}
                  </h3>
                  <p className="text-white/90 text-[15px] leading-relaxed mt-1.5">{r.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
